/** Existing approved Admin fonts, embedded in the offline print copy rather than fetched by it. */
const assetFetch = globalThis.fetch?.bind(globalThis);
const assets = (): Array<{ families: Array<string>; weight: number; style?: 'normal' | 'italic'; url: string }> => [
  { families: ['Suisse Intl', "Suisse Int'l"], weight: 400, url: require('~/assets/fonts/SuisseIntl-Regular.woff2') },
  { families: ['Suisse Intl', "Suisse Int'l"], weight: 450, url: require('~/assets/fonts/SuisseIntl-Book.woff2') },
  { families: ['Suisse Intl', "Suisse Int'l"], weight: 500, url: require('~/assets/fonts/SuisseIntl-Medium.woff2') },
  { families: ['Suisse Intl', "Suisse Int'l"], weight: 600, url: require('~/assets/fonts/SuisseIntl-SemiBold.woff2') },
  { families: ['Suisse Intl', "Suisse Int'l"], weight: 700, url: require('~/assets/fonts/SuisseIntl-Bold.woff2') },
  {
    families: ['Lens Suisse Works', 'Suisse Works'],
    weight: 400,
    url: require('~/assets/fonts/SuisseWorks-Regular.woff2'),
  },
  {
    families: ['Lens Suisse Works', 'Suisse Works'],
    weight: 450,
    style: 'italic',
    url: require('~/assets/fonts/SuisseWorks-BookItalic.woff2'),
  },
  {
    families: ['Lens Suisse Works', 'Suisse Works'],
    weight: 500,
    url: require('~/assets/fonts/SuisseWorks-Medium.woff2'),
  },
];
let embedded: Promise<string> | undefined;

export async function lensPrintFontCss(): Promise<string> {
  embedded ??= Promise.all(
    assets().map(async ({ families, weight, style = 'normal', url }) => {
      if (!assetFetch) throw new Error('Print fonts could not be loaded.');
      const response = await assetFetch(url);
      if (!response.ok) throw new Error('Print fonts could not be loaded.');
      const bytes = new Uint8Array(await response.arrayBuffer());
      let binary = '';
      for (let offset = 0; offset < bytes.length; offset += 0x8000)
        binary += String.fromCharCode(...bytes.subarray(offset, offset + 0x8000));
      const data = `data:font/woff2;base64,${btoa(binary)}`;
      return families
        .map(
          (family) =>
            `@font-face{font-family:${JSON.stringify(family)};font-style:${style};font-weight:${weight};src:url(${data}) format('woff2')}`,
        )
        .join('\n');
    }),
  )
    .then((faces) => faces.join('\n'))
    .catch((error) => {
      embedded = undefined;
      throw error;
    });
  return embedded;
}
